import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';

import ModalDialog from '../../../ModalDialog';
import styles from './exportDataModal.module.css';
import TextInput from '../../../TextInput';
import Checkbox from '../../../Checkbox';

const EXPORT_REASON_MAX_LENGTH = 100;

const ExportDataModal = ({
  isOpen,
  onClose,
  onSubmit,
  clearTextArea
}) => {
  const [textAreaValue, setTextAreaValue] = useState('');
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const exportReasonLength = textAreaValue.trim().length;
  const validReasonLength = exportReasonLength > 0 && exportReasonLength <= EXPORT_REASON_MAX_LENGTH;

  const handleTextAreaChange = (e) => setTextAreaValue(e.target.value);
  const handleCheckboxChange = (e) => setIsCheckboxChecked(e.target.checked);

  const handleConfirm = () => {
    onSubmit(textAreaValue.trim());
  };

  useEffect(() => {
    if (isOpen) {
      document.getElementById('textarea').focus();
    } else if (!isOpen) {
      // Uncheck if closed but keep text-area state
      setIsCheckboxChecked(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (clearTextArea) setTextAreaValue('');
  }, [clearTextArea]);

  return (
    <ModalDialog
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onCancel={onClose}
      isValid={isCheckboxChecked && validReasonLength}
      confirmTranslationKey="survey.export.excel"
      cancelTranslationKey="common.close"
      title="survey.export.sensitiveExcel"
      variantButtons
    >
      <p><Translate id="survey.export.description" /></p>
      <div className={styles.textAreaContainer}>
        <label htmlFor="textarea">
          <Translate id="survey.export.enterReason" />
        </label>
        <TextInput
          value={textAreaValue}
          onChange={handleTextAreaChange}
          maxLength={EXPORT_REASON_MAX_LENGTH}
          className={styles.textArea}
          textarea
          id="textarea"
        />

      </div>
      <Checkbox
        id="checkbox"
        labelTranslationKey="survey.export.checkbox"
        isChecked={isCheckboxChecked}
        onChange={handleCheckboxChange}
        required
      />
    </ModalDialog>
  );
};

const {
  bool, func
} = PropTypes;

ExportDataModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  clearTextArea: bool.isRequired
};

export default ExportDataModal;
